import { render } from "./VideocallListBooking.vue?vue&type=template&id=35663c95&scoped=true"
import script from "./VideocallListBooking.vue?vue&type=script&lang=js"
export * from "./VideocallListBooking.vue?vue&type=script&lang=js"

import "./VideocallListBooking.vue?vue&type=style&index=0&id=35663c95&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35663c95"]])

export default __exports__